package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2023_06_30_Day_1
import com.veldekar.components.logs.Log_2023_06_30_Day_2
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2023-06-30")
@Composable
public fun Log_2023_06_30(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Shrine to Silpion",
        ogTitle = "Shrine to Silpion",
        date = LocalDate(2_023, 6, 30),
        ogDescription = "After looting the Yuan-ti, the party continues downstream and discovers a shrine to the water goddess Silpion.",
        ogImage = "ai/2023-06-30.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-30", dateString = "Newgrowth 30")
        Log_2023_06_30_Day_1()
        SessionDayHeader(dayId = "newgrowth-31", dateString = "Newgrowth 31")
        Log_2023_06_30_Day_2()
    }
}
